module.exports = __webpack_public_path__ + "img/balkon.f2744dd2.webp";